var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _path9, _g4, _path10, _path11, _g5, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 49,
    viewBox: "0 0 166 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1557_5589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 11,
    width: 12,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8533 11.4333H13.9535V37.5457H24.8533V11.4333Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1557_5589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1557_5589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 11,
    width: 12,
    height: 27
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8533 11.4333H13.9535V37.5457H24.8533V11.4333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1557_5589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9535 11.4333V37.5667L24.8533 19.1184L13.9535 11.4333Z",
    fill: "#1799D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1557_5589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 11,
    width: 12,
    height: 27
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0002 11.4333H40.1003V37.5457H51.0002V11.4333Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1557_5589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1557_5589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 11,
    width: 12,
    height: 27
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0002 11.4333H40.1003V37.5457H51.0002V11.4333Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1557_5589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1003 19.1184L50.979 37.5667V11.4333L40.1003 19.1184Z",
    fill: "#1799D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1557_5589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 6,
    width: 17,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1005 6.21924H24.8534V24.5H40.1005V6.21924Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1557_5589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1557_5589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 6,
    width: 17,
    height: 19
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1005 6.21924H24.8534V24.5H40.1005V6.21924Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1557_5589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1005 19.1184L32.4663 6.21924L24.8534 19.1184L32.4663 24.5L40.1005 19.1184Z",
    fill: "#1799D5"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9535 37.5667H50.979L32.4663 24.5L13.9535 37.5667Z",
    fill: "#1799D5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1557_5589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 19,
    width: 19,
    height: 19
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9791 19.1184H32.4663V37.5458H50.9791V19.1184Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1557_5589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1557_5589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 19,
    width: 19,
    height: 19
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9791 19.1184H32.4663V37.5458H50.9791V19.1184Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1557_5589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4663 24.5L50.9791 37.5667L40.1004 19.1184L32.4663 24.5Z",
    fill: "#1799D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1557_5589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 19,
    width: 20,
    height: 19
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4663 19.1184H13.9535V37.5458H32.4663V19.1184Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1557_5589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1557_5589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 19,
    width: 20,
    height: 19
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4663 19.1184H13.9535V37.5458H32.4663V19.1184Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1557_5589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8533 19.1184L13.9535 37.5667L32.4663 24.5L24.8533 19.1184Z",
    fill: "#1799D5"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.979 40.1632H13.9535V42.7807H50.979V40.1632Z",
    fill: "#1799D5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2651 2.13586H64.9325V46.8641H67.2651V2.13586Z",
    fill: "#CBD2DD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8819 29.7769H85.1205L83.2544 35.3679H79.1193L86.9018 13.5273H91.1006L98.8832 35.3679H94.748L92.8819 29.7769ZM89.0012 17.3175C89.0012 17.3175 88.4923 19.4744 88.0682 20.7098L86.096 26.5521H91.8852L89.9131 20.7098C89.5102 19.4744 89.0436 17.3175 89.0436 17.3175H88.98H89.0012Z",
    fill: "#15284B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.898 13.5273H104.821V29.9026C104.821 31.6197 105.415 32.0594 106.433 32.0594C107.45 32.0594 107.026 32.0385 107.026 32.0385V35.4517C107.026 35.4517 106.433 35.5355 105.775 35.5355C103.591 35.5355 100.877 34.991 100.877 30.4889V13.5483L100.898 13.5273Z",
    fill: "#15284B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.953 13.5273H113.876V17.0034H109.953V13.5273ZM109.953 19.6838H113.918V35.3679H109.953V19.6838Z",
    fill: "#15284B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.288 38.509C126.727 38.509 128.784 37.5039 128.784 34.6979V33.7765C128.784 33.3996 128.847 32.9389 128.847 32.9389H128.784C127.85 34.321 126.472 35.0539 124.352 35.0539C119.813 35.0539 117.226 31.4312 117.226 27.1176C117.226 22.8039 119.686 19.3069 124.267 19.3069C128.847 19.3069 128.974 21.2962 128.974 21.2962H129.059C129.059 21.2962 129.038 21.1077 129.038 20.8565V19.6629H132.749V34.4047C132.749 39.7864 128.508 41.8176 124.373 41.8176C120.238 41.8176 120.259 41.2731 118.732 40.4565L119.919 37.462C119.919 37.462 121.913 38.4671 124.309 38.4671L124.288 38.509ZM128.868 27.1594C128.868 23.5996 127.087 22.6364 124.945 22.6364C122.803 22.6364 121.213 24.3535 121.213 27.0129C121.213 29.6723 122.655 31.7872 125.2 31.7872C127.744 31.7872 128.868 30.7193 128.868 27.1804V27.1594Z",
    fill: "#15284B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.096 19.6838H140.892V21.5056C140.892 22.0919 140.829 22.5736 140.829 22.5736H140.892C141.571 21.2543 143.331 19.3069 146.533 19.3069C149.735 19.3069 152.046 21.1287 152.046 25.2748V35.368H148.123V26.0706C148.123 24.165 147.636 22.8667 145.6 22.8667C143.564 22.8667 141.931 24.1859 141.337 26.0706C141.125 26.7197 141.062 27.4317 141.062 28.1646V35.368H137.096V19.6838Z",
    fill: "#15284B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.34f97f5550054dfd28c9c3003bb7395b.svg";
export { ForwardRef as ReactComponent };